'use client';

/*
 * Documentation:
 * Dialog — https://app.subframe.com/6fc7f5fbb098/library?component=Dialog_ca59db17-43fb-4247-8094-3c55162e902d
 */
import { c as _c } from "react/compiler-runtime";
import React from 'react';
import * as SubframeCore from '@subframe/core';
import * as SubframeUtils from '../utils';
interface ContentProps extends React.ComponentProps<typeof SubframeCore.Dialog.Content> {
  children?: React.ReactNode;
  className?: string;
}
const Content = React.forwardRef<HTMLDivElement, ContentProps>(function Content(t0, ref) {
  const $ = _c(9);
  let children;
  let className;
  let otherProps;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = otherProps;
  } else {
    children = $[1];
    className = $[2];
    otherProps = $[3];
  }
  let t1;
  if ($[4] !== children || $[5] !== className || $[6] !== otherProps || $[7] !== ref) {
    t1 = children ? <SubframeCore.Dialog.Content asChild={true} {...otherProps}><div className={SubframeUtils.twClassNames("bg-default-background flex max-h-[90vh] min-w-[320px] flex-col items-start gap-2 overflow-auto rounded-md border border-solid border-neutral-200 shadow-md", className)} ref={ref}>{children}</div></SubframeCore.Dialog.Content> : null;
    $[4] = children;
    $[5] = className;
    $[6] = otherProps;
    $[7] = ref;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
});
interface DialogRootProps extends React.ComponentProps<typeof SubframeCore.Dialog.Root> {
  children?: React.ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  className?: string;
}
const DialogRoot = React.forwardRef<HTMLDivElement, DialogRootProps>(function DialogRoot(t0, ref) {
  const $ = _c(9);
  let children;
  let className;
  let otherProps;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = otherProps;
  } else {
    children = $[1];
    className = $[2];
    otherProps = $[3];
  }
  let t1;
  if ($[4] !== children || $[5] !== className || $[6] !== otherProps || $[7] !== ref) {
    t1 = children ? <SubframeCore.Dialog.Root asChild={true} {...otherProps}><div className={SubframeUtils.twClassNames("fixed inset-0 z-[9999] flex h-full w-full flex-col items-center justify-center gap-2 bg-[#00000099]", className)} ref={ref}>{children}</div></SubframeCore.Dialog.Root> : null;
    $[4] = children;
    $[5] = className;
    $[6] = otherProps;
    $[7] = ref;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
});
export const Dialog = Object.assign(DialogRoot, {
  Content
});